import * as api from '../resources/documents.api';
import actionTypes from './action-types';

export const setNewLabelStatusRequest = () => ({
  type: actionTypes.SET_NEW_LABEL_STATUS_REQUEST,
});

export const setNewLabelStatusSuccess = (status) => ({
  type: actionTypes.SET_NEW_LABEL_STATUS_SUCCESS,
  status,
});

export const setNewLabelStatusFailure = () => ({
  type: actionTypes.SET_NEW_LABEL_STATUS_FAILURE,
});

export const setNewLabelStatus = () => async (dispatch) => {
  try {
    dispatch(setNewLabelStatusRequest());

    await api.setNewLabelStatus();
    dispatch(setNewLabelStatusSuccess(false));
  } catch (error) {
    console.error('SET_NEW_LABEL_STATUS', error);
    dispatch(setNewLabelStatusFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/documents/actions/set-new-label-status.actions.js